import PropTypes from "prop-types";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import GroupMemberLeaveDialog from "features/groups/components/GroupMemberLeaveDialog";
import GroupMemberAdminLeaveDialog from "features/groups/components/GroupMemberAdminLeaveDialog";
import { ReactComponent as VerifiedIcon } from "assets/images/icons/verified.svg";
import "features/groups/assets/styles/GroupLeaveLabel.scss";

const GroupMemberLeaveButton = ({ groupMemberId, isPrivate, isAdmin, onCompleted }) => {
  const { showDialog } = useDialog();
  const leaveDialog = isAdmin ?
    <GroupMemberAdminLeaveDialog/>
    :
    <GroupMemberLeaveDialog groupMemberId={ groupMemberId }
                            isPrivate={ isPrivate }
                            onCompleted={ onCompleted }/>;

  const onConfirm = () => {
    showDialog(leaveDialog);
  }

  return (
      <>
        <span className={"group-leave-label"}>
          <VerifiedIcon/>U bent groepslid
        </span>
        <Button variant={ `ghost` } onClick={ onConfirm }>Verlaten</Button>
      </>
  );
}

GroupMemberLeaveButton.propTypes = {
  groupMemberId: PropTypes.number,
  isPrivate: PropTypes.bool.isRequired,
}

export default GroupMemberLeaveButton;
